<template>
  <div>
    <PageTitle
      title="Payment Details"
      :backBtn="true"
      :permission="'Purchase Edit'"
    />
    <v-container
      fluid
      class="lighten-12 container"
      style="background-color: white"
    >
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12" class="py-1 px-5">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title saletiltle"
              ><v-icon color="blue" small>mdi-sale</v-icon
              ><span class="ml-3"> Payment </span></v-card-title
            >
            <v-container fluid class="container saledetailscard">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                  <v-row class="pt-0 mb-5">
                    <v-col
                      cols="12"
                      sm="12"
                      md="4"
                      lg="4"
                      class="pr-5 pt-1.5 pb-1 reference_number"
                    >
                      <v-icon>mdi-sale</v-icon>
                      {{
                        PaymentDetails.reference_number
                          ? PaymentDetails.reference_number
                          : '----'
                      }}
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4">
                      <span class="statustext pr-5">Status</span>
                      <v-chip
                        label
                        text-color="white"
                        :color="GetChequeStatusColor(PaymentDetails.status)"
                        dark
                        class="orderData"
                      >
                        {{ PaymentDetails.status }}
                      </v-chip>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="12"
                      md="3"
                      lg="3"
                      v-if="PaymentDetails.cheque_no"
                    >
                      <span class="statustext pr-5">Cheque No</span>
                      <v-chip
                        color="green"
                        class="pa-0 pulse pointer"
                        outlined
                        @click="$router.push({ path: '/cheque', params: 4 })"
                      >
                        {{ PaymentDetails.cheque_no }}
                      </v-chip>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="3"
                      lg="3"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Date </v-row>
                      <v-row>
                        <v-icon small class="mr-1">mdi-calendar</v-icon>
                        {{ PaymentDetails.date_time | formatDate }}
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Amount </v-row>
                      <v-row>
                        Rs. {{ PaymentDetails.amount | formatCurrency }}
                      </v-row>
                    </v-col>

                    <v-col cols="1" sm="12" md="1" lg="1" class="shoptext">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Payment Type </v-row>
                      <v-row>
                        {{ PaymentDetails.payment_type }}
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Remarks </v-row>
                      <v-row>
                        {{
                          PaymentDetails.remarks
                            ? PaymentDetails.remarks
                            : '----'
                        }}
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
          class="py-1 px-5"
          v-if="PaymentDetails.paymentable_type === 'purchase'"
        >
          <v-card class="lighten-12">
            <v-card-title class="v-card__title saletiltle"
              ><v-icon color="blue" small>mdi-sale</v-icon
              ><span class="ml-3"> Purchase </span></v-card-title
            >
            <v-container fluid class="container saledetailscard">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                  <v-row class="pt-0 mb-5">
                    <v-col
                      cols="12"
                      sm="12"
                      md="5"
                      lg="5"
                      class="pr-5 pt-1.5 pb-1 reference_number"
                    >
                      <v-icon>mdi-sale</v-icon>
                      {{
                        PaymentDetails.purchase.reference_number
                          ? PaymentDetails.purchase.reference_number
                          : '----'
                      }}
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4">
                      <span class="statustext pr-5">Total Amount</span>
                      <span class="font-weight-bold"
                        >Rs.
                        {{
                          PaymentDetails.purchase.total_amount | formatCurrency
                        }}</span
                      >
                    </v-col>
                    <v-col>
                      <span class="statustext pr-5">Paid Amount</span>
                      <span class="font-weight-bold"
                        >Rs.
                        {{
                          PaymentDetails.purchase.paid_amount | formatCurrency
                        }}</span
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="3"
                      lg="3"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Date </v-row>
                      <v-row>
                        <v-icon small class="mr-1">mdi-calendar</v-icon>
                        {{ PaymentDetails.purchase.date | formatDate }}
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Supplier </v-row>
                      <v-row>
                        {{ PaymentDetails.purchase.supplier.name }}
                      </v-row>
                    </v-col>

                    <v-col cols="1" sm="12" md="1" lg="1" class="shoptext">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Purchase from </v-row>
                      <v-row>
                        {{ PaymentDetails.purchase.purchase_from }}
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Discount </v-row>
                      <v-row>
                        Rs.
                        {{
                          PaymentDetails.purchase.discount_amount
                            | formatCurrency
                        }}
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
          class="py-1 px-5"
          v-if="PaymentDetails.paymentable_type === 'sale'"
        >
          <v-card class="lighten-12">
            <v-card-title class="v-card__title saletiltle"
              ><v-icon color="blue" small>mdi-sale</v-icon
              ><span class="ml-3"> Sale </span></v-card-title
            >
            <v-container fluid class="container saledetailscard">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                  <v-row class="pt-0 mb-5">
                    <v-col
                      cols="12"
                      sm="12"
                      md="5"
                      lg="5"
                      class="pr-5 pt-1.5 pb-1 reference_number"
                    >
                      <v-icon>mdi-sale</v-icon>
                      {{
                        PaymentDetails.sale.reference_number
                          ? PaymentDetails.sale.reference_number
                          : '----'
                      }}
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4">
                      <span class="statustext pr-5">Total Amount</span>
                      <span class="font-weight-bold"
                        >Rs. {{ PaymentDetails.sale.total }}</span
                      >
                    </v-col>
                    <v-col>
                      <span class="statustext pr-5">Discount</span>
                      <span class="font-weight-bold"
                        >Rs. {{ PaymentDetails.sale.discount_amount }}</span
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="3"
                      lg="3"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Biller </v-row>
                      <v-row>
                        {{ PaymentDetails.sale.biller.first_name }}
                      </v-row>
                    </v-col>

                    <v-col cols="1" sm="12" md="1" lg="1" class="shoptext">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Customer </v-row>
                      <v-row>
                        {{ PaymentDetails.sale.customer.name }}
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="3"
                      lg="3"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Shop </v-row>
                      <v-row>
                        {{ PaymentDetails.sale.shop.name }}
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                      <!-- <v-divider></v-divider> -->
                    </v-col>
                    <!-- <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="shoptext pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Status </v-row>
                      <v-row>
                        <v-chip
                          label
                          text-color="white"
                          class="orderData pulse"
                          :color="
                            GetChequeStatusColor(
                              PaymentDetails.sale.payment_status
                            )
                          "
                          dark
                        >
                          {{ PaymentDetails.sale.payment_status }}
                        </v-chip>
                      </v-row>
                    </v-col> -->
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="px-2">
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12 py-0">
            <v-card-title class="py-0">Files</v-card-title>
            <v-container fluid class="container saledetailscard">
              <v-row> </v-row>
              <v-row>
                <v-col cols="12">
                  <FileUpload
                    :multiple="true"
                    size="2048"
                    icon="mdi-upload"
                    autoupload="true"
                    :url="'document/upload/payment/' + this.$route.params.id"
                    :showDocumentView="true"
                    :documentsUrl="'document/payment/' + this.$route.params.id"
                    downloadUrl="document/:id/download"
                    removeUrl="document/:id"
                  ></FileUpload>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12">
          <AuditLogs :Type="'payments'" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { PurchaseViewModel } from '@/models/View Models/PurchaseViewModel';
import { PaymentViewModel } from '@/models/View Models/PaymentViewModel';
import FileUpload from '@/components/base/FileUpload';
import DocumentView from '@/components/base/DocumentView';
import AddPaymentModel from '../../shared/modals/AddPaymentModel';
import AdditionalAmountModel from '../../shared/modals/AddAdditionalAmountModal';
import EditPaymentModel from '../../shared/modals/EditPaymentModel';
import { AccountViewModel } from '../../../models/View Models/AccountViewModel';
import { Payment } from '@/models/Payment';
import 'jspdf-autotable';
import VueDocPreview from 'vue-doc-preview';
import confirmation from '@/modules/shared/components/confirmation';

export default {
  data: () => ({
    PaymentDetails: [],
    redirected: {},
  }),
  methods: {
    GetPayment() {
      this.paymentId = this.$route.params.id;
      this.$store
        .dispatch('purchase/GetPaymentById', { paymentId: this.paymentId })
        .then((res) => {
          this.PaymentDetails = res;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    getPurchaseOrderStatusColor(status) {
      switch (status) {
        case 'Received':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;
        default:
          break;
      }
    },
    onPaymentClick(event) {
      if (event.paymentable_type == 'purchase') {
        this.$router.push(`/purchase/${event.purchase.id}`);
      }
      if (event.paymentable_type == 'sale') {
        this.$router.push(`/sales/view/${event.sale.id}`);
      }
    },

    GetChequeStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;
        case 'Return':
          return '#973a5a';
          break;
        default:
          break;
      }
    },
    DocumentView() {
      var fileId = this.$route.params.id;
      var documentType = 'Payment';
      this.$store
        .dispatch('DocumentView', {
          fileId,
          documentType,
        })
        .then((resp) => {});
    },
  },

  components: {
    FileUpload,
    EditPaymentModel,
    DocumentView,
    AddPaymentModel,
    AdditionalAmountModel,
    VueDocPreview,
  },
  created() {
    // this.DocumentView();
    this.GetPayment();
  },
  computed: {
    // printQr() {
    //   return {
    //     id: "purchase",
    //     popTitle: this.Purchase.referenceNumber,
    //   };
    // },
  },
};
</script>

<style scoped>
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.pointer {
  cursor: pointer;
}
.shoptext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.statustext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: center;

  color: #045894;
}
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
  padding: 0 !important;
  padding-left: 10px !important;
}
.pulse {
  background: #2c44cc;

  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(102, 15, 15, 0.4);
    box-shadow: 0 0 0 0 rgba(6, 173, 233, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 0 rgba(102, 15, 15, 0.4);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(102, 15, 15, 0.4);
    box-shadow: 0 0 0 0 rgba(179, 52, 30, 0);
  }
}
</style>
